import React from 'react';
import { Link } from 'react-router-dom';
import { useSEO } from '../utils/useSEO';

const NotFoundPage = () => {
  useSEO({ title: 'Page Not Found' });

  return (
    <div className="min-h-screen bg-slate-50 flex flex-col items-center justify-center px-4">
      <h1 className="text-6xl font-bold text-brand mb-4">404</h1>
      <p className="text-xl text-slate-700 mb-2">Page not found</p>
      <p className="text-slate-500 mb-8">The page you're looking for doesn't exist.</p>
      <div className="flex gap-4">
        <Link to="/" className="btn btn-primary">Go Home</Link>
        <Link to="/search" className="btn btn-secondary">Browse Events</Link>
      </div>
    </div>
  );
};

export default NotFoundPage;
